import saleDeletedFullcont from './saleDeleted-fullcont.html'

const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const saleDeletedMenu = require('./saleDeleted-menu')
const handler = require('./saleDeleted-fullcont-handler')
const { form, formCopy } = require('./saleDeleted-fullcont-form')
const { saleDeletedMT } = require('./saleDeleted-fullcont-multitable')
const customerQuickview = require('../customer/customer-quickview')

const htmlFc = {}
let HTMLwasSelected = false

function HTMLselect() {
  fullcontHandler.HTMLselect(
    'saleDeleted',
    'saleDeleted',
    'saleDeleted-fullcont',
    saleDeletedFullcont,
    form,
    formCopy,
    saleDeletedMT,
    readOnlyAction,
    readOnlyAction,
    undefined,
    htmlFc
  )

  handler.initDataFc(htmlFc)
  htmlFc.fullcontHTML.classList.add('mode-readOnly', 'mode-view')
  HTMLwasSelected = true
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect()

  const action = actions[detail.act]
  if (action) action(detail)
}

const actions = {
  fullcontOptions: detail => saleDeletedMenu.start(detail, 'htmlDt', htmlFc),
  hide: detail => fullcontEntity.hide(detail, htmlFc),
  restore: () => handler.restoreSale(htmlFc),
  selectOne: detail => fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne),
  showcost: () => handler.showcost(htmlFc),
  showreturn: () => handler.showreturn(htmlFc),
  obtenerIdCustomer: () => showCustomer()
}

function showCustomer() {
  const container = htmlFc.fullcontHTML.querySelector('#saleDeleted_form_customer_id')
  const rawFields = container?.querySelector('.otherField')?.getAttribute('otherField')

  if (rawFields && rawFields !== 'undefined' && rawFields !== 'null') {
    try {
      const customer = JSON.parse(rawFields)
      if (customer?.id_customer) {
        customerQuickview.start({
          dest: 'customer',
          elem: 'quickview',
          act: 'getExtraData',
          idCustomer: customer.id_customer
        })
        return
      }
    } catch (error) {
      // Customer data is optional in this read-only view.
    }
  }

}

function processAfterSelectOne(data, result) {
  handler.fill_InventoryStock(data)
  handler.dtgenerator(result, htmlFc)
  handler.emailTrackingGenerator(result, htmlFc)

  const showCost = htmlFc.fullcontHTML.querySelector('#showcost')
  if (showCost) {
    showCost.checked = false
    showCost.dispatchEvent(new Event('change'))
  }

  const returnTab = htmlFc.fullcontHTML.querySelector('#return')
  if (returnTab) returnTab.classList.remove('dn')

  const showReturn = htmlFc.fullcontHTML.querySelector('#showreturn')
  if (showReturn) {
    showReturn.checked = false
    showReturn.dispatchEvent(new Event('change'))
  }

  enforceReadOnly()
}

function enforceReadOnly() {
  htmlFc.fullcontHTML.classList.add('mode-view', 'mode-readOnly')
  htmlFc.fullcontHTML.classList.remove('mode-edit', 'mode-add')

  htmlFc.fullcontHTML.querySelectorAll('input, select, textarea, button').forEach(element => {
    if (element.id === 'showcost' || element.id === 'showreturn') {
      element.disabled = false
      element.removeAttribute('readonly')
      return
    }

    element.disabled = true
    element.setAttribute('readonly', 'readonly')
  })

  htmlFc.fullcontHTML
    .querySelectorAll('.fab-to-edit, .fab-to-add, .fab-to-update, .fab-to-readOnly, .removeLine, .btn')
    .forEach(element => element.classList.add('dn'))
}

function readOnlyAction() {
  return false
}
